/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Hierarchy_OneInputs */

const en_sch_err_hierarchy_one = /** @type {(inputs: Sch_Err_Hierarchy_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 parent and child pair would break, so nothing was changed.`)
};

const de_sch_err_hierarchy_one = /** @type {(inputs: Sch_Err_Hierarchy_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Paar aus übergeordnetem und untergeordnetem Vorgang würde brechen, deshalb wurde nichts geändert.`)
};

/**
* | output |
* | --- |
* | "1 parent and child pair would break, so nothing was changed." |
*
* @param {Sch_Err_Hierarchy_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_hierarchy_one = /** @type {((inputs?: Sch_Err_Hierarchy_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Hierarchy_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_hierarchy_one(inputs)
	return en_sch_err_hierarchy_one(inputs)
});